const $ = window.jQuery

if ($.validator != null) {
  $.validator.addMethod('positive-number-greater-than-zero', (value) => {
    const positiveNumberRegex = /^[1-9][0-9]*$/
    return value != null && positiveNumberRegex.test(value)
  }, $('body').data('msg-positive-number-greater-than-zero'))
}

$(() => {
  if (window.initializeChosen) {
    window.initializeChosen()
  }

  const forms = $('form.validate')

  forms.each((i, form) => {
    const $form = $(form)

    $form.validate({
      errorClass: 'error',
      errorElement: 'span',
      focusInvalid: false,
      invalidHandler: (form, validator) => {
        if (validator.numberOfInvalids() <= 0) {
          return
        }

        if ($('html, body').outerWidth() <= 480) {
          const scrollTop = $(validator.errorList[0].element).offset().top - ($('.header').outerHeight() + 50)
          $('html, body').animate({
            scrollTop: scrollTop
          }, Math.max(200, Math.abs(scrollTop - window.pageYOffset)))
        }
      },
      ignore: '.ignore', // Don't ignore hidden fields (chosen)

      errorPlacement: ($error, $element) => {
        const chosenEnabled = window.chosenBrowserIsSupported()
        let $errorElement = $element

        if (chosenEnabled && $element.is('select')) {
          $errorElement = $element.siblings('.chosen-container')
        }

        if ($element.attr('type') === 'checkbox') {
          $error.insertBefore($errorElement)
        } else {
          $error.insertAfter($errorElement)
        }

        $errorElement.addClass('error')
      },

      success: (error, element) => {
        const chosenEnabled = window.chosenBrowserIsSupported()
        const $element = $(element)

        let $errorElement = $element
        if (chosenEnabled && $element.is('select')) {
          $errorElement = $element.siblings('.chosen-container')
        }

        error.remove()
        $errorElement.removeClass('error')
      }
    })
  })
})

$(() => {
  const $body = $('body')

  const getMessage = (identifier) => {
    if (!$body.attr(`data-msg-${identifier}`)) {
      console.error(`Missing translation-data on body-element: data-msg-${identifier}="···"`)
    }

    return $body.data(`msg-${identifier}`)
  }

  $.extend($.validator.messages, {
    required: getMessage('required'),
    email: getMessage('email')
  })
})

$(() => {
  const $forms = $('form[data-form-action]')

  $forms.each((i, form) => {
    const $form = $(form)

    $form.on('submit', () => {
      if ($form.hasClass('validate') && !$form.valid()) {
        return // Only submit valid forms
      }

      const $formElement = $form.find('.form')
      const $workIndicatorElement = $form.find('.work-indicator')
      const $successElement = $form.find('.success')

      $formElement.hide()
      $workIndicatorElement.show()

      const formData = $form.serialize()

      $.ajax({
        type: 'POST',
        url: $form.data('form-action'),
        data: formData,
        success: () => {
          if (window.PaymentWindow != null) {

            $.ajax({
              type: 'POST',
              url: `${hostname}/umbraco/surface/Webshop/SaveCurrentOrder/`,
              data: { },
              success: (response) => {
                if (response.Completed) {
                  window.location = window.accepturl
                  return
                }
                const salt = 'sedquamerat'
                const options = {
                  merchantnumber: '1030745', // development: 8030745
                  amount: `${response.TotalPriceIncludingShipping * 100}`,
                  currency: 'DKK',
                  orderid: `${response.PageId}`,
                  accepturl: window.accepturl,
                  cancelurl: window.cancelurl,
                  callbackurl: `${window.location.protocol}//${window.location.host}/umbraco/surface/Webshop/PaymentCallback/`
                }

                let tmp = ""
                Object.keys(options).map(key => tmp += options[key])
                options.hash = CryptoJS.MD5(tmp + salt)

                const paymentwindow = new PaymentWindow(options);
                paymentwindow.open()
              }
            }).fail((...args) => { // This should never happen
              console.error('Could not POST', ...args)
              window.alert('Error - please try again')
            })
          } else {
            const redirectUrl = $form.data('form-success-redirect')
            if (!(redirectUrl == null)) {
              window.location = redirectUrl
            } else {
              $workIndicatorElement.hide()
              $successElement.show()
            }
          }
        }
      }).fail(() => { // This should never happen
        $workIndicatorElement.hide()
        $formElement.show()
        window.alert('Error - please try again')
      })

      // Prevent default behaviour
      return false
    })
  })
})
